import React from "react";
import CustomCard from "../../shared/Card/CustomCard";
import ServiceForm from "./ServiceForm";

export default function EditService({ name }) {
    return (
        <CustomCard title={name}>
            <ServiceForm type="EDIT" />
        </CustomCard>
    );
}
